import React from "react";
import styles from "./style.module.scss";
import classNames from "classnames/bind";

import Loading from "components/shared/Icon/Loading";

const Button = ({ text, icon,className, onClickButton, cancel, cancelGray, loading ,outline}) => {
  return (
    <button
      className={classNames(
        outline ? styles.buttonOutline:styles.button,
        cancel && styles.button__cancel,
        cancelGray && styles.button__cancel_gray,
        className
      )}
      onClick={onClickButton}
    >
      {icon && <i className={ (outline ? styles.buttonOutline__icon:styles.button__icon)  + " " + icon}  />}
      <span className={outline ? styles.buttonOutline__text:styles.button__text}>
        <span>{text}</span>
        {loading && <Loading />}
      </span>
    </button>
  );
};

export default Button;
